import React, { useEffect, useRef, useState } from 'react'
import "./MembershipCustomTextContent.css"
import CalendlyFormModal from '../CalendlyFormEmbed/CalendlyFormEmbed'
import { useNavigate } from 'react-router-dom'


let cardData = [
    {
        img:"/images/creatives/women-text-1.png",
        title:"70% of Cardiac arrests and cancers stem from preventable causes",
        para:"We work actively on lifestyle and environmental management to support our patients and coach them into optimal health"
    },
    {
        img:"/images/creatives/women-text-1.png",
        title:"Cutting-edge preventative care to optimize your health",
        para:"Still account for the most common causes of death in the western hemisphere. 70% of them are preventable"
    },
    {
        img:"/images/creatives/women-text-1.png",
        title:"Keeping you healthy for as long as possible",
        para:"Still account for the most common causes of death in the western hemisphere. 70% of them are preventable"
    },
]

function MembershipCustomTextContent(
    {
        subHeading="A new approach",
        heading=null,
        listData,
        shiftRow=false,
        nonSwitchingImg=false,
        buttonText=null,
        cardDataProp=cardData,
        limitizeMaxWIdth=false,
        btnCalnedly=false,
        calendlyType=0
    }
) {
     if(listData)
      {
        cardData = listData
        cardDataProp = listData
      }
    
        const [selected, setSelected] = useState(1);
        const [openCalendly, setOpenCalendly] = useState(false);
        const [picture,SetPicture] = useState(cardDataProp[0].img)
      const [fadeClass, setFadeClass] = useState("fade-in");
   const cardRef = useRef()
      const [boxHeight,setBoxHeight] = useState("180px")

      useEffect(()=>{
          const recalcHeight = ()=>{
            setBoxHeight(`${cardRef.current?.offsetWidth}px`)
          }
    
          recalcHeight()
    
          window.addEventListener("resize", recalcHeight);
          return () => window.removeEventListener("resize", recalcHeight);
        },[])
     

    const handleSelect = (type) => {
    if (type !== selected) {
      setFadeClass("fade-out");
      setTimeout(() => {
        setSelected(type)
        switch (type) {
            case 1:
                SetPicture(cardDataProp[0].img)
                break;
        
            case 2:
                SetPicture(cardDataProp[1].img)
                break;
        
            case 3:
                SetPicture(cardDataProp[2].img)
                break;
        
            default:
                break;
        }
        setFadeClass("fade-in");
      }, 300); 
    }
  };
  const navigate = useNavigate()
  return (
    <>
        
        {
            openCalendly &&
            <CalendlyFormModal  intialOpenState={openCalendly} setOpenState={setOpenCalendly} calendlyType={calendlyType}/>
        }
    <div className='MembershipCustomTextContent-container standard-padding-space'>
        <div className='container'>
            <div className={`row align-items-center ${shiftRow? "flex-row-reverse":"flex-row"} `}>
                 <div className='col-lg-6 d-flex align-items-center justify-content-center' >
                    {/* <img src={picture} className={`img-fluid ${fadeClass}`} style={{borderRadius:"15px",height:boxHeight,width:"100%",maxWidth:`${limitizeMaxWIdth?"400px":"100%"}`}} ref={cardRef} /> */}
                    <img src={picture} className={`img-fluid ${fadeClass}`} style={{borderRadius:"15px",height:"auto",width:"100%",maxWidth:`${limitizeMaxWIdth?"400px":"100%"}`}} ref={cardRef} />
                    {/* <div className={`${fadeClass}`} style={{borderRadius:"20px",height:boxHeight,width:"100%",backgroundImage:`url(${picture})`,backgroundSize:'cover',backgroundPosition:'center left',maxWidth:`${limitizeMaxWIdth?"400px":"100%"}`}} ref={cardRef} >

</div> */}

                </div>
                <div className='col-lg-6'>
                    <h5 className='sub-heading color-blue'>{subHeading}</h5>
                    <h3 className='body-heading mb-3'>{heading? heading:
                        <>It's About <span className='color-blue'>preventing</span> disease, not just fighting it.</>
                        }</h3>

                    {
                        cardDataProp.map((ele,ind)=>{
                            return(
                                <div className='content-card d-flex align-items-start gap-2 p-3 ' onMouseOver={()=>{if(!nonSwitchingImg){handleSelect(ind+1)}}}>
                                    <img src='/images/icons/blue-heart-icon.png' className='img-fluid pt-1' style={{width:"25px",borderRadius:"50%"}} />
                                    <div>
                                       {ele?.title && <h5 className='body-heading' style={{fontSize:"1.2rem"}}>{ele.title}</h5>}
                                        <p className='body-paragraph mb-0'>{ele.para}</p>
                                    </div>
                                </div>
                            )
                        })
                    }

                    {
                        buttonText &&
                        <button className='genral-btn mt-4' onClick={()=>{if(btnCalnedly){setOpenCalendly(true)}else{navigate("/membership")}}}>{buttonText}</button>
                    }
                </div>
               

            </div>
        </div>
    </div>
    </>
  )
}

export default MembershipCustomTextContent